// Generated by scripts/generate-api-types.sh from the api schema on
// the live lake. Do not edit by hand.
//
// Every field is optional and nullable because PostgREST returns only the
// columns a request asked for, and a view column with no NOT NULL can be
// null. Both facts have to survive into the types, or a screen reads a
// missing value as present and renders it as empty rather than as absent.

export type Database = {
  api: {
    Tables: Record<string, never>;
    Functions: {
      add_contact_point: {
        Args: {
          p_person_id: string;
          p_kind: string;
          p_value: string;
          p_note?: string;
        };
        Returns: string;
      };
      add_feed: {
        Args: {
          p_feed_url: string;
          p_name?: string;
          p_category?: string;
        };
        Returns: unknown;
      };
      archive_criteria_set: {
        Args: {
          p_name: string;
          p_archived?: boolean;
        };
        Returns: boolean;
      };
      assign_campaign: {
        Args: {
          p_name: string;
          p_owner?: string;
        };
        Returns: unknown;
      };
      build_crm_export: {
        Args: {
          p_criteria_sets: string[];
          p_since?: string;
          p_leave_out_other_owners?: boolean;
          p_refresh?: boolean;
        };
        Returns: string;
      };
      build_lead_sheet: {
        Args: {
          p_criteria_sets: string[];
          p_order?: string;
          p_since?: string;
          p_leave_out_other_owners?: boolean;
          p_refresh?: boolean;
        };
        Returns: string;
      };
      build_orum_export: {
        Args: {
          p_criteria_sets: string[];
          p_since?: string;
          p_leave_out_other_owners?: boolean;
          p_refresh?: boolean;
          p_mark_calling?: boolean;
        };
        Returns: string;
      };
      build_thin_export: {
        Args: {
          p_name: string;
          p_who?: string;
          p_gap?: string;
        };
        Returns: string;
      };
      call_angle_stages: {
        Args: {
          p_filters: unknown;
        };
        Returns: string[];
      };
      campaign_cut_preview: {
        Args: {
          p_name: string;
          p_per_role?: number;
          p_per_company?: number;
          p_reach_fill?: boolean;
        };
        Returns: unknown;
      };
      campaign_export_count: {
        Args: {
          p_name: string;
          p_leave_out_other_owners?: boolean;
        };
        Returns: unknown;
      };
      campaign_people_count: {
        Args: {
          p_name: string;
          p_who?: string;
          p_gap?: string;
          p_leave_out_other_owners?: boolean;
        };
        Returns: unknown;
      };
      company_search: {
        Args: {
          p_q: string;
        };
        Returns: unknown;
      };
      compare_with_campaign: {
        Args: {
          p_import: string;
          p_campaign: string;
        };
        Returns: string;
      };
      complete_enrichment: {
        Args: {
          p_name: string;
          p_note?: string;
        };
        Returns: unknown;
      };
      contested_facts: {
        Args: {
          p_entity_type: string;
          p_entity_id: string;
        };
        Returns: unknown;
      };
      create_campaign: {
        Args: {
          p_name: string;
          p_label: string;
          p_filters: unknown;
          p_weights?: unknown;
          p_description?: string;
          p_auto_enrich?: boolean;
          p_ask_enricher?: boolean;
          p_roles?: string[];
          p_seniorities?: string[];
          p_contact_state?: string;
          p_research?: unknown;
          p_call_notes?: unknown;
          p_owner?: string;
          p_contact_cut?: number;
          p_per_role?: number;
          p_per_company?: number;
          p_reach_fill?: boolean;
          p_ask_apollo?: boolean;
          p_start_enrichment?: string;
          p_enrich_on?: string;
          p_call_on?: string;
          p_after?: string;
          p_before?: string;
        };
        Returns: string;
      };
      criteria_filter_names: {
        Args: Record<string, never>;
        Returns: string[];
      };
      criteria_filter_problems: {
        Args: {
          p_filters: unknown;
        };
        Returns: string;
      };
      decide_review: {
        Args: {
          p_id: number;
          p_decision: string;
        };
        Returns: unknown;
      };
      edit_grace_days: {
        Args: Record<string, never>;
        Returns: number;
      };
      edit_record: {
        Args: {
          p_entity_type: string;
          p_entity_id: string;
          p_changes: unknown;
          p_note?: string;
        };
        Returns: unknown;
      };
      email_resubscribe: {
        Args: {
          p_template_key: string;
        };
        Returns: void;
      };
      email_unsubscribe: {
        Args: {
          p_template_key: string;
        };
        Returns: void;
      };
      flag_record: {
        Args: {
          p_entity_type: string;
          p_entity_id: string;
          p_reason: string;
          p_note: string;
          p_duplicate_of?: string;
        };
        Returns: string;
      };
      import_mapping_for: {
        Args: {
          p_headers: string[];
        };
        Returns: unknown;
      };
      load_csv: {
        Args: {
          p_key: string;
          p_headers: string[];
          p_mapping: unknown;
          p_source: string;
          p_as_of?: string;
        };
        Returns: string;
      };
      measure_campaign: {
        Args: {
          p_name: string;
        };
        Returns: unknown;
      };
      model_calls_allowed: {
        Args: Record<string, never>;
        Returns: boolean;
      };
      model_calls_stop: {
        Args: Record<string, never>;
        Returns: unknown;
      };
      move_campaign: {
        Args: {
          p_name: string;
          p_stage: string;
          p_look_on_web?: boolean;
          p_request_manual?: boolean;
          p_ask_apollo?: boolean;
        };
        Returns: unknown;
      };
      person_search: {
        Args: {
          p_q: string;
        };
        Returns: unknown;
      };
      processing_history: {
        Args: {
          p_window?: string;
        };
        Returns: unknown;
      };
      processing_passes: {
        Args: {
          p_worker: string;
        };
        Returns: unknown;
      };
      processing_sample: {
        Args: {
          p_worker: string;
          p_work_kind?: string;
        };
        Returns: unknown;
      };
      processing_schedule: {
        Args: {
          p_window?: string;
        };
        Returns: unknown;
      };
      processing_series: {
        Args: {
          p_window?: string;
        };
        Returns: unknown;
      };
      processing_window: {
        Args: {
          p_window?: string;
        };
        Returns: unknown;
      };
      project_label: {
        Args: {
          p_id: string;
        };
        Returns: string;
      };
      property_contacts: {
        Args: {
          p_property_id: string;
          p_campaign?: string;
        };
        Returns: unknown;
      };
      queue_campaign_enrichment: {
        Args: {
          p_criteria_set: string;
          p_cap?: number;
          p_who?: string;
        };
        Returns: unknown;
      };
      queue_enrichment: {
        Args: {
          p_entity_type: string;
          p_entity_id: string;
          p_reason?: string;
        };
        Returns: boolean;
      };
      read_csv: {
        Args: {
          p_key: string;
          p_source: string;
          p_as_of?: string;
          p_mapping?: unknown;
        };
        Returns: string;
      };
      record_campaigns: {
        Args: {
          p_entity_type: string;
          p_entity_id: string;
        };
        Returns: unknown;
      };
      register_import: {
        Args: {
          p_key: string;
          p_format: string;
          p_marks?: unknown;
        };
        Returns: string;
      };
      report_screen_error: {
        Args: {
          p_screen: string;
          p_message: string;
          p_detail?: string;
        };
        Returns: number;
      };
      request_apollo_enrichment: {
        Args: {
          p_name: string;
          p_who?: string;
          p_gap?: string;
        };
        Returns: string;
      };
      request_apollo_fill: {
        Args: {
          p_entity_type: string;
          p_entity_id: string;
        };
        Returns: string;
      };
      request_enrichment: {
        Args: {
          p_name: string;
        };
        Returns: unknown;
      };
      review_pair: {
        Args: {
          p_id: number;
        };
        Returns: unknown;
      };
      review_side: {
        Args: {
          p_type: string;
          p_id: string;
        };
        Returns: unknown;
      };
      run_campaign: {
        Args: {
          p_criteria_set: string;
          p_limit?: number;
        };
        Returns: string;
      };
      run_web_enrichment_again: {
        Args: {
          p_name: string;
        };
        Returns: unknown;
      };
      save_criteria_set: {
        Args: {
          p_name: string;
          p_filters: unknown;
          p_label?: string;
          p_description?: string;
          p_entity_type?: string;
          p_weights?: unknown;
          p_shape?: unknown;
        };
        Returns: string;
      };
      schedule_campaign: {
        Args: {
          p_name: string;
          p_enrich_on?: string;
          p_call_on?: string;
        };
        Returns: unknown;
      };
      score_factor_names: {
        Args: Record<string, never>;
        Returns: string[];
      };
      sequence_campaign: {
        Args: {
          p_name: string;
          p_after?: string;
          p_before?: string;
        };
        Returns: unknown;
      };
      set_call_notes: {
        Args: {
          p_name: string;
          p_angles: unknown;
          p_incentives: string;
          p_closing: string;
        };
        Returns: unknown;
      };
      set_campaign_status: {
        Args: {
          p_name: string;
          p_status: string;
        };
        Returns: string;
      };
      set_edit_grace: {
        Args: {
          p_days: number;
        };
        Returns: void;
      };
      set_email_recipient: {
        Args: {
          p_role: string;
          p_addresses: string[];
        };
        Returns: void;
      };
      set_email_sending: {
        Args: {
          p_enabled: boolean;
        };
        Returns: void;
      };
      set_email_template: {
        Args: {
          p_key: string;
          p_subject: string;
          p_body_text: string;
          p_body_html?: string;
          p_enabled?: boolean;
        };
        Returns: void;
      };
      set_enrichment_options: {
        Args: {
          p_name: string;
          p_auto_enrich: boolean;
          p_roles?: string[];
          p_seniorities?: string[];
          p_contact_state?: string;
          p_research?: unknown;
          p_contact_cut?: number;
          p_per_role?: number;
          p_per_company?: number;
          p_reach_fill?: boolean;
        };
        Returns: unknown;
      };
      set_event_status: {
        Args: {
          p_id: number;
          p_status: string;
          p_note: string;
        };
        Returns: string;
      };
      set_extract_first: {
        Args: {
          p_on: boolean;
        };
        Returns: void;
      };
      set_kind_allowance: {
        Args: {
          p_kind: string;
          p_per_day: number;
        };
        Returns: void;
      };
      set_kind_priority: {
        Args: {
          p_kind: string;
          p_priority: string;
          p_until?: string;
        };
        Returns: void;
      };
      set_lookup_depth: {
        Args: {
          p_kind: string;
          p_searches?: number;
          p_results?: number;
        };
        Returns: void;
      };
      set_lookup_window: {
        Args: {
          p_outcome: string;
          p_recheck_days: number;
          p_backoff: number;
          p_max_days: number;
        };
        Returns: void;
      };
      set_model_calls_paused: {
        Args: {
          p_until?: string;
        };
        Returns: void;
      };
      set_new_company_lookups: {
        Args: {
          p_on: boolean;
        };
        Returns: void;
      };
      set_review_decides: {
        Args: {
          p_kind: string;
          p_on: boolean;
        };
        Returns: void;
      };
      set_spend_limit: {
        Args: {
          p_cap: number;
          p_reserve: number;
          p_override_until?: string;
        };
        Returns: void;
      };
      set_worker_pace: {
        Args: {
          p_worker: string;
          p_batch?: number;
          p_every_seconds?: number;
          p_concurrency?: number;
          p_paused?: boolean;
        };
        Returns: void;
      };
      spend_state: {
        Args: Record<string, never>;
        Returns: unknown;
      };
      start_enrichment: {
        Args: {
          p_name: string;
        };
        Returns: unknown;
      };
      submit_capture: {
        Args: {
          p_key: string;
          p_url: string;
          p_title?: string;
        };
        Returns: string;
      };
      submit_feedback: {
        Args: {
          p_category: string;
          p_body: string;
          p_importance?: string;
          p_url?: string;
          p_route?: string;
          p_page_title?: string;
          p_entity_type?: string;
          p_entity_id?: string;
          p_app_version?: string;
          p_user_agent?: string;
          p_viewport?: string;
          p_recent_errors?: unknown;
        };
        Returns: number;
      };
      submit_url: {
        Args: {
          p_url: string;
          p_crawl?: boolean;
        };
        Returns: string;
      };
      undo_import: {
        Args: {
          p_job_id: string;
        };
        Returns: string;
      };
      undo_review: {
        Args: {
          p_id: number;
        };
        Returns: unknown;
      };
      update_field: {
        Args: {
          p_entity_type: string;
          p_entity_id: string;
          p_field: string;
          p_value: string;
          p_source?: string;
        };
        Returns: string;
      };
      web_sweep_size: {
        Args: {
          p_records: number;
        };
        Returns: unknown;
      };
      withdraw_enrichment: {
        Args: {
          p_name: string;
        };
        Returns: unknown;
      };
    };
    Views: {
      campaign: {
        Row: {
          id?: string | null;
          name?: string | null;
          label?: string | null;
          description?: string | null;
          entity_type?: string | null;
          filters?: unknown | null;
          weights?: unknown | null;
          shape?: unknown | null;
          created_by?: string | null;
          created_at?: string | null;
          updated_at?: string | null;
          archived_at?: string | null;
          stage?: string | null;
          stage_order?: number | null;
          stage_at?: string | null;
          stage_by?: string | null;
          auto_enrich?: boolean | null;
          manual_status?: string | null;
          manual_requested_at?: string | null;
          manual_requested_by?: string | null;
          manual_assigned_to?: string | null;
          manual_started_at?: string | null;
          manual_completed_at?: string | null;
          manual_completed_by?: string | null;
          manual_note?: string | null;
          roles?: string[] | null;
          seniorities?: string[] | null;
          contact_state?: string | null;
          research?: unknown | null;
          list_id?: string | null;
          list_at?: string | null;
          list_count?: number | null;
          list_by?: string | null;
          list_note?: string | null;
          list_job_id?: string | null;
          list_job_status?: string | null;
          list_job_error?: string | null;
          measured_at?: string | null;
          properties?: number | null;
          companies?: number | null;
          people?: number | null;
          people_with_mobile?: number | null;
          contacts_need_work?: number | null;
          properties_need_work?: number | null;
          joined_since?: number | null;
          left_since?: number | null;
          not_yet_delivered?: number | null;
          last_export_kind?: string | null;
          last_export_at?: string | null;
          last_export_by?: string | null;
          export_count?: number | null;
          export_job_id?: string | null;
          export_job_kind?: string | null;
          export_job_status?: string | null;
          enrich_job_id?: string | null;
          enrich_job_status?: string | null;
          enrich_batch?: string | null;
          web_members?: number | null;
          web_waiting?: number | null;
          web_expected_done_at?: string | null;
          apollo_open?: number | null;
          last_activity_at?: string | null;
          situation?: string | null;
          where_it_stands?: string | null;
          next_step?: string | null;
          next_step_label?: string | null;
          enrich_job_error?: string | null;
          enrich_job_finished_at?: string | null;
          web_candidates?: number | null;
          lookup_pace_per_hour?: number | null;
          web_queue_hours?: number | null;
          web_needs_confirm?: boolean | null;
          stage_moves?: string[] | null;
          people_with_email?: number | null;
          owners_need_work?: number | null;
          owner_id?: string | null;
          owner_name?: string | null;
          owner_email?: string | null;
          owner_since?: string | null;
          owner_by?: string | null;
          created_by_name?: string | null;
          stage_by_name?: string | null;
          contact_cut?: number | null;
          contact_cut_in_use?: number | null;
          people_taken_at?: string | null;
          properties_with_nobody?: number | null;
          people_everyone?: number | null;
          people_everyone_without_mobile?: number | null;
          contact_per_role?: number | null;
          contact_per_company?: number | null;
          contact_reach_fill?: boolean | null;
          enrich_on?: string | null;
          call_on?: string | null;
          ask_enricher?: boolean | null;
          ask_apollo?: boolean | null;
          calling_words?: string | null;
          calling_warning?: boolean | null;
          criteria_changed_at?: string | null;
          list_behind?: boolean | null;
          list_behind_words?: string | null;
          follows_name?: string | null;
          follows_label?: string | null;
          followed_by_name?: string | null;
          followed_by_label?: string | null;
          sequence_place?: number | null;
          sequence_length?: number | null;
          sequence_head_name?: string | null;
          sequence_words?: string | null;
          enrichment_rank?: number | null;
          enrichment_words?: string | null;
          people_ahead?: number | null;
          sequence_order?: number | null;
          when_calling_words?: string | null;
          when_done_words?: string | null;
          when_out_words?: string | null;
        };
      };
      campaign_build: {
        Row: {
          campaign?: string | null;
          list_id?: string | null;
          at?: string | null;
          by_name?: string | null;
          properties?: number | null;
          previous_count?: number | null;
          first?: boolean | null;
          joined?: number | null;
          left_count?: number | null;
          reasons_recorded?: boolean | null;
          note?: string | null;
        };
      };
      campaign_change: {
        Row: {
          campaign?: string | null;
          list_id?: string | null;
          change?: string | null;
          cause?: string | null;
          why?: string | null;
          reasons?: unknown | null;
          property_id?: string | null;
          in_evie?: boolean | null;
          label?: string | null;
          city?: string | null;
          state?: string | null;
          id?: string | null;
        };
      };
      campaign_compare: {
        Row: {
          job_id?: string | null;
          import_job_id?: string | null;
          campaign?: string | null;
          status?: string | null;
          error?: string | null;
          queued_at?: string | null;
          finished_at?: string | null;
          asked_by?: string | null;
          list_id?: string | null;
          list_at?: string | null;
          ran_at?: string | null;
          totals?: unknown | null;
          reasons?: unknown | null;
          people?: unknown | null;
          companies?: unknown | null;
          criteria?: unknown | null;
        };
      };
      campaign_compare_row: {
        Row: {
          job_id?: string | null;
          seq?: number | null;
          property_id?: string | null;
          label?: string | null;
          city?: string | null;
          state?: string | null;
          status?: string | null;
          rank?: number | null;
          reasons?: unknown | null;
        };
      };
      campaign_export_history: {
        Row: {
          job_id?: string | null;
          kind?: string | null;
          criteria_set_id?: string | null;
          criteria_set_name?: string | null;
          requested_by?: string | null;
          status?: string | null;
          queued_at?: string | null;
          finished_at?: string | null;
          artifact?: string | null;
          error?: string | null;
          artifact_key?: string | null;
        };
      };
      campaign_history: {
        Row: {
          campaign?: string | null;
          at?: string | null;
          kind?: string | null;
          what?: string | null;
          by_name?: string | null;
          rows?: number | null;
          list_id?: string | null;
          job_id?: string | null;
          has_file?: boolean | null;
          failed?: boolean | null;
          note?: string | null;
          seq?: number | null;
          file?: string | null;
        };
      };
      campaign_list: {
        Row: {
          member_id?: string | null;
          list_id?: string | null;
          rank?: number | null;
          score?: number | null;
          breakdown?: unknown | null;
          property_id?: string | null;
          name?: string | null;
          address_line1?: string | null;
          city?: string | null;
          state?: string | null;
          property_type?: string | null;
          unit_count?: number | null;
          owner_company_id?: string | null;
          owner_company_name?: string | null;
          project_status?: string | null;
          stage_word?: string | null;
          stage_order?: number | null;
          people_to_call?: number | null;
          people_with_mobile?: number | null;
          people_taken_at?: string | null;
        };
      };
      campaign_overlap: {
        Row: {
          campaign?: string | null;
          property_id?: string | null;
          people?: number | null;
          other_owner_name?: string | null;
          other_campaign?: string | null;
          other_label?: string | null;
          sent_at?: string | null;
          words?: string | null;
        };
      };
      campaign_people: {
        Row: {
          campaign?: string | null;
          criteria_set_id?: string | null;
          list_id?: string | null;
          property_id?: string | null;
          person_id?: string | null;
          full_name?: string | null;
          title?: string | null;
          role_category?: string | null;
          level?: string | null;
          employer_id?: string | null;
          employer_name?: string | null;
          basis?: string | null;
          company_role?: string | null;
          project_role?: string | null;
          fit?: number | null;
          reasons?: string[] | null;
          above_line?: boolean | null;
          rank_in_property?: number | null;
          call_order?: number | null;
          email?: string | null;
          mobile?: string | null;
          phone?: string | null;
          linkedin_url?: string | null;
          taken_at?: string | null;
        };
      };
      campaign_progress: {
        Row: {
          criteria_set_id?: string | null;
          criteria_set_name?: string | null;
          baseline_at?: string | null;
          measured_at?: string | null;
          properties?: number | null;
          companies?: number | null;
          people?: number | null;
          people_with_mobile?: number | null;
          people_with_email?: number | null;
          people_with_linkedin?: number | null;
          properties_added?: number | null;
          properties_left?: number | null;
          companies_change?: number | null;
          people_change?: number | null;
          mobiles_change?: number | null;
          emails_change?: number | null;
          last_export_id?: string | null;
          last_export_at?: string | null;
          not_yet_delivered?: number | null;
          needs_work?: unknown | null;
          gaps?: unknown | null;
          needs_words?: string | null;
          added_by_method?: unknown | null;
          properties_with_nobody?: number | null;
          people_everyone?: number | null;
          people_everyone_without_mobile?: number | null;
        };
      };
      campaign_result: {
        Row: {
          id?: string | null;
          campaign_id?: string | null;
          campaign_name?: string | null;
          entity_type?: string | null;
          entity_id?: string | null;
          rank?: number | null;
          score?: number | null;
          tier?: string | null;
          breakdown?: unknown | null;
          entity_label?: string | null;
          entity_subtitle?: string | null;
          created_at?: string | null;
        };
      };
      campaign_run: {
        Row: {
          id?: string | null;
          name?: string | null;
          criteria_set_id?: string | null;
          criteria_set_name?: string | null;
          ruleset_id?: string | null;
          ruleset_version?: string | null;
          ruleset_active?: boolean | null;
          criteria_snapshot?: unknown | null;
          destination?: string | null;
          run_by?: string | null;
          member_count?: number | null;
          frozen_at?: string | null;
          notes?: string | null;
          thin_count?: number | null;
          job_id?: string | null;
          since_campaign_id?: string | null;
          kind?: string | null;
        };
      };
      candidate_property: {
        Row: {
          id?: string | null;
          name?: string | null;
          address_line1?: string | null;
          city?: string | null;
          state?: string | null;
          zip?: string | null;
          county?: string | null;
          property_type?: string | null;
          unit_count?: number | null;
          affordable_flag?: boolean | null;
          parking_spaces?: number | null;
          has_existing_ev_chargers?: boolean | null;
          chargers_state?: string | null;
          lat?: number | null;
          lon?: number | null;
          jurisdiction_name?: string | null;
          owner_company_id?: string | null;
          owner_company_name?: string | null;
          owner_website?: string | null;
          owner_party_kind?: string | null;
          owner_firm_role?: string | null;
          owner_in_hubspot?: boolean | null;
          stakeholder_role?: string | null;
          portfolio_size?: number | null;
          portfolio_states?: number | null;
          portfolio_units?: number | null;
          people_connected?: number | null;
          owner_senior?: number | null;
          people_to_call?: number | null;
          owner_emails?: number | null;
          owner_mobiles?: number | null;
          owner_linkedins?: number | null;
          ordinance_count?: number | null;
          ordinance_local_count?: number | null;
          ordinance_state_count?: number | null;
          requires_evse?: boolean | null;
          preempted?: boolean | null;
          right_to_charge?: boolean | null;
          program_count?: number | null;
          best_rate_pct?: number | null;
          project_id?: string | null;
          project_status?: string | null;
          project_kind?: string | null;
          project_name?: string | null;
          project_units?: number | null;
          est_completion?: string | null;
          groundbreaking_at?: string | null;
          announced_at?: string | null;
          construction_status?: string | null;
          data_source?: string | null;
          source_link?: string | null;
          source_seen?: string | null;
          standing_stock?: boolean | null;
          has_reachable_person?: boolean | null;
          has_connected_person?: boolean | null;
          has_email?: boolean | null;
          has_mobile?: boolean | null;
          has_linkedin?: boolean | null;
          has_units?: boolean | null;
          has_coordinates?: boolean | null;
          has_owner?: boolean | null;
          has_ordinance?: boolean | null;
          has_local_ordinance?: boolean | null;
          has_program?: boolean | null;
          year_built?: number | null;
          year_renovated?: number | null;
          building_class?: string | null;
          stories?: number | null;
          stage_word?: string | null;
          year_expected_completion?: number | null;
          year_construction_start?: number | null;
          year_permit_estimate?: number | null;
        };
      };
      candidate_state_count: {
        Row: {
          state?: string | null;
          properties?: number | null;
          with_reachable_person?: number | null;
        };
      };
      capture: {
        Row: {
          id?: string | null;
          url?: string | null;
          title?: string | null;
          submitted_by?: string | null;
          submitted_at?: string | null;
          processing_status?: string | null;
        };
      };
      capture_record: {
        Row: {
          signal_id?: string | null;
          entity_type?: string | null;
          entity_id?: string | null;
          label?: string | null;
          address?: string | null;
          is_new?: boolean | null;
        };
      };
      company: {
        Row: {
          id?: string | null;
          name?: string | null;
          kind?: string | null;
          website?: string | null;
          hq_city?: string | null;
          hq_state?: string | null;
          relevance?: string | null;
          relevance_reason?: string | null;
          do_not_contact?: boolean | null;
          do_not_contact_reason?: string | null;
          source_count?: number | null;
          signal_count?: number | null;
          newest_source_date?: string | null;
          source_tiers?: string[] | null;
          hubspot_status?: string | null;
          hubspot_checked_at?: string | null;
          hubspot_company_id?: string | null;
          property_count?: number | null;
          people_count?: number | null;
          created_at?: string | null;
          updated_at?: string | null;
          counted_at?: string | null;
          hubspot_last_contacted_at?: string | null;
          hubspot_last_activity_at?: string | null;
          hubspot_last_activity?: string | null;
          hubspot_owner?: string | null;
          hubspot_contact_count?: number | null;
        };
      };
      company_project: {
        Row: {
          company_id?: string | null;
          project_id?: string | null;
          name?: string | null;
          kind?: string | null;
          status?: string | null;
          stage_word?: string | null;
          unit_count?: number | null;
          announced_at?: string | null;
          groundbreaking_at?: string | null;
          est_completion?: string | null;
          newest_source_date?: string | null;
          source_count?: number | null;
          property_id?: string | null;
          property_name?: string | null;
          property_city?: string | null;
          property_state?: string | null;
          roles?: string[] | null;
          standing?: string | null;
        };
      };
      company_property: {
        Row: {
          company_id?: string | null;
          company_name?: string | null;
          company_kind?: string | null;
          property_id?: string | null;
          property_name?: string | null;
          property_address_line1?: string | null;
          property_city?: string | null;
          property_state?: string | null;
          property_type?: string | null;
          unit_count?: number | null;
          roles?: string[] | null;
          ended_roles?: string[] | null;
          standing?: string | null;
          last_confirmed_at?: string | null;
          source_count?: number | null;
        };
      };
      contact: {
        Row: {
          basis?: string | null;
          parent_type?: string | null;
          parent_id?: string | null;
          property_id?: string | null;
          person_id?: string | null;
          full_name?: string | null;
          project_role?: string | null;
          title?: string | null;
          level?: string | null;
          job_function?: string | null;
          employment_standing?: string | null;
          effective_standing?: string | null;
          employment_relevance?: string | null;
          employer_id?: string | null;
          employer_name?: string | null;
          employer_kind?: string | null;
          email?: string | null;
          mobile?: string | null;
          phone?: string | null;
          linkedin_url?: string | null;
          person_city?: string | null;
          person_state?: string | null;
        };
      };
      criteria_set: {
        Row: {
          id?: string | null;
          name?: string | null;
          description?: string | null;
          entity_type?: string | null;
          filters?: unknown | null;
          weights?: unknown | null;
          shape?: unknown | null;
          enrich?: unknown | null;
          ruleset_id?: string | null;
          ruleset_version?: string | null;
          ruleset_active?: boolean | null;
          created_by?: string | null;
          created_at?: string | null;
          updated_at?: string | null;
          archived_at?: string | null;
          run_count?: number | null;
          last_run_at?: string | null;
          label?: string | null;
          status?: string | null;
          status_at?: string | null;
          status_by?: string | null;
          last_snapshot_id?: string | null;
          last_snapshot_at?: string | null;
          last_snapshot_destination?: string | null;
          export_count?: number | null;
          last_export_at?: string | null;
          auto_enrich?: boolean | null;
          manual_status?: string | null;
          manual_requested_at?: string | null;
          manual_requested_by?: string | null;
          manual_assigned_to?: string | null;
          manual_started_at?: string | null;
          manual_completed_at?: string | null;
          manual_completed_by?: string | null;
          manual_note?: string | null;
          manual_history?: unknown | null;
          roles?: string[] | null;
          seniorities?: string[] | null;
          contact_state?: string | null;
          research?: unknown | null;
          enrich_job_id?: string | null;
          enrich_job_status?: string | null;
          enrich_job_queued_at?: string | null;
          enrich_batch?: string | null;
          contact_cut?: number | null;
          contact_per_role?: number | null;
          contact_per_company?: number | null;
          contact_reach_fill?: boolean | null;
        };
      };
      editable_field: {
        Row: {
          entity_type?: string | null;
          field?: string | null;
          data_type?: string | null;
          required?: boolean | null;
          allowed_values?: string[] | null;
          label?: string | null;
        };
      };
      email_outbox: {
        Row: {
          id?: number | null;
          template_key?: string | null;
          template_label?: string | null;
          to_address?: string | null;
          status?: string | null;
          status_reason?: string | null;
          subject?: string | null;
          requested_by?: string | null;
          created_at?: string | null;
          sent_at?: string | null;
          delivered_at?: string | null;
          attempts?: number | null;
        };
      };
      email_recipient: {
        Row: {
          role?: string | null;
          addresses?: string[] | null;
          description?: string | null;
          updated_by?: string | null;
          updated_at?: string | null;
        };
      };
      email_template: {
        Row: {
          key?: string | null;
          label?: string | null;
          description?: string | null;
          subject?: string | null;
          body_text?: string | null;
          body_html?: string | null;
          unsubscribable?: boolean | null;
          enabled?: boolean | null;
          updated_by?: string | null;
          updated_at?: string | null;
        };
      };
      employment: {
        Row: {
          id?: string | null;
          person_id?: string | null;
          person_name?: string | null;
          company_id?: string | null;
          company_name?: string | null;
          company_kind?: string | null;
          title?: string | null;
          level?: string | null;
          job_function?: string | null;
          territory?: string | null;
          standing?: string | null;
          effective_standing?: string | null;
          effective_from?: string | null;
          effective_to?: string | null;
          last_confirmed_at?: string | null;
          relevance?: string | null;
          relevance_reason?: string | null;
          confidence?: string | null;
          created_at?: string | null;
          updated_at?: string | null;
          title_raw?: string | null;
        };
      };
      enrichment_batch: {
        Row: {
          batch?: string | null;
          members?: number | null;
          queued?: number | null;
          found?: number | null;
          no_result?: number | null;
          unreachable?: number | null;
          signals?: number | null;
          signals_open?: number | null;
          signals_resolved?: number | null;
          first_looked_at?: string | null;
          last_looked_at?: string | null;
          done?: boolean | null;
          waiting?: number | null;
          never_queued?: number | null;
          waiting_ahead?: number | null;
          pace_per_hour?: number | null;
          expected_done_at?: string | null;
        };
      };
      enrichment_gap_count: {
        Row: {
          campaign?: string | null;
          entity_type?: string | null;
          gap?: string | null;
          label?: string | null;
          records?: number | null;
        };
      };
      enrichment_member: {
        Row: {
          batch?: string | null;
          entity_type?: string | null;
          entity_id?: string | null;
          label?: string | null;
          outcome?: string | null;
          looked_at?: string | null;
          signals?: unknown | null;
          employment?: unknown | null;
          employment_since_lookup?: number | null;
        };
      };
      enrichment_owner: {
        Row: {
          campaign?: string | null;
          criteria_set_id?: string | null;
          measured_at?: string | null;
          walk_order?: number | null;
          company_id?: string | null;
          company_name?: string | null;
          website?: string | null;
          hq_city?: string | null;
          hq_state?: string | null;
          property_id?: string | null;
          property_name?: string | null;
          property_city?: string | null;
          property_state?: string | null;
          reasons?: string[] | null;
          missing?: string[] | null;
          property_address?: string | null;
        };
      };
      enrichment_person: {
        Row: {
          campaign?: string | null;
          criteria_set_id?: string | null;
          measured_at?: string | null;
          walk_order?: number | null;
          person_id?: string | null;
          full_name?: string | null;
          employment_id?: string | null;
          title?: string | null;
          employer_id?: string | null;
          employer_name?: string | null;
          property_id?: string | null;
          property_name?: string | null;
          property_city?: string | null;
          property_state?: string | null;
          mobile?: string | null;
          email?: string | null;
          phone?: string | null;
          linkedin_url?: string | null;
          reasons?: string[] | null;
          missing?: string[] | null;
          title_editable?: boolean | null;
          property_address?: string | null;
        };
      };
      enrichment_property: {
        Row: {
          campaign?: string | null;
          criteria_set_id?: string | null;
          measured_at?: string | null;
          walk_order?: number | null;
          property_id?: string | null;
          property_name?: string | null;
          address_line1?: string | null;
          city?: string | null;
          state?: string | null;
          unit_count?: number | null;
          stage_word?: string | null;
          reasons?: string[] | null;
          missing?: string[] | null;
        };
      };
      enrichment_request: {
        Row: {
          id?: string | null;
          name?: string | null;
          label?: string | null;
          status?: string | null;
          created_by?: string | null;
          auto_enrich?: boolean | null;
          manual_status?: string | null;
          manual_requested_at?: string | null;
          manual_requested_by?: string | null;
          manual_assigned_to?: string | null;
          manual_started_at?: string | null;
          manual_completed_at?: string | null;
          manual_completed_by?: string | null;
          manual_note?: string | null;
          roles?: string[] | null;
          seniorities?: string[] | null;
          contact_state?: string | null;
          research?: unknown | null;
          measured_at?: string | null;
          properties?: number | null;
          people?: number | null;
          people_with_mobile?: number | null;
          needs_work?: unknown | null;
          gaps?: unknown | null;
          needs_words?: string | null;
          properties_since_request?: number | null;
          mobiles_since_request?: number | null;
          people_since_request?: number | null;
          enrich_job_id?: string | null;
          enrich_job_status?: string | null;
          enrich_batch?: string | null;
          web_members?: number | null;
          web_waiting?: number | null;
          web_expected_done_at?: string | null;
          apollo_jobs_open?: number | null;
          properties_with_nobody?: number | null;
          people_everyone?: number | null;
          people_everyone_without_mobile?: number | null;
          contact_cut?: number | null;
          contact_cut_in_use?: number | null;
          call_on?: string | null;
          calling_words?: string | null;
          calling_warning?: boolean | null;
          follows_label?: string | null;
          sequence_place?: number | null;
          sequence_words?: string | null;
          enrichment_rank?: number | null;
          enrichment_words?: string | null;
          people_ahead?: number | null;
        };
      };
      enrichment_scenario: {
        Row: {
          key?: string | null;
          name?: string | null;
          roles?: string[] | null;
          seniorities?: string[] | null;
          sort_order?: number | null;
        };
      };
      enrichment_state: {
        Row: {
          entity_type?: string | null;
          entity_id?: string | null;
          state?: string | null;
          requested_at?: string | null;
          requested_by?: string | null;
          reason?: string | null;
          priority?: number | null;
          last_looked_at?: string | null;
          outcome?: string | null;
          attempts?: number | null;
          batch?: string | null;
          recheck_days?: number | null;
          requeueable_after?: string | null;
        };
      };
      entity_name: {
        Row: {
          entity_type?: string | null;
          entity_id?: string | null;
          name?: string | null;
          source?: string | null;
          first_seen?: string | null;
          last_seen?: string | null;
          seen_count?: number | null;
          source_url?: string | null;
        };
      };
      event: {
        Row: {
          id?: number | null;
          first_seen_at?: string | null;
          last_seen_at?: string | null;
          occurrences?: number | null;
          source?: string | null;
          kind?: string | null;
          severity?: string | null;
          subject?: string | null;
          summary?: string | null;
          detail?: string | null;
          status?: string | null;
          status_at?: string | null;
          status_by?: string | null;
          status_note?: string | null;
          closed_at?: string | null;
        };
      };
      feed: {
        Row: {
          id?: string | null;
          name?: string | null;
          feed_url?: string | null;
          feed_type?: string | null;
          category?: string | null;
          scope?: string | null;
          status?: string | null;
          first_party?: boolean | null;
          source_name?: string | null;
          last_polled_at?: string | null;
          next_poll_at?: string | null;
          last_item_at?: string | null;
          poll_interval_minutes?: number | null;
          consecutive_failures?: number | null;
          last_status?: string | null;
          last_error?: string | null;
          items_seen?: number | null;
          items_kept?: number | null;
          keep_rate_pct?: number | null;
          productive?: boolean | null;
          due_now?: boolean | null;
          created_at?: string | null;
        };
      };
      feed_category: {
        Row: {
          category?: string | null;
          feeds?: number | null;
          productive?: number | null;
          active?: number | null;
          failing?: number | null;
          items_seen?: number | null;
          items_kept?: number | null;
          keep_rate_pct?: number | null;
          last_polled_at?: string | null;
        };
      };
      feed_summary: {
        Row: {
          feeds?: number | null;
          active?: number | null;
          candidate?: number | null;
          paused?: number | null;
          dead?: number | null;
          productive?: number | null;
          failing?: number | null;
          due_now?: number | null;
          items_seen?: number | null;
          items_kept?: number | null;
          polled_24h?: number | null;
        };
      };
      gap_word: {
        Row: {
          key?: string | null;
          label?: string | null;
          short_words?: string | null;
          need_words?: string | null;
        };
      };
      import_field: {
        Row: {
          target?: string | null;
          kind?: string | null;
          label?: string | null;
          position?: number | null;
        };
      };
      import_outcome: {
        Row: {
          job_id?: string | null;
          entity_type?: string | null;
          outcome?: string | null;
          held?: boolean | null;
          records?: number | null;
        };
      };
      import_record: {
        Row: {
          job_id?: string | null;
          signal_id?: string | null;
          entity_type?: string | null;
          entity_id?: string | null;
          label?: string | null;
          address?: string | null;
          outcome?: string | null;
          held?: boolean | null;
        };
      };
      import_value: {
        Row: {
          target?: string | null;
          value?: string | null;
          label?: string | null;
          position?: number | null;
        };
      };
      ingestion_record: {
        Row: {
          signal_id?: string | null;
          entity_type?: string | null;
          entity_id?: string | null;
          link_kind?: string | null;
          created_at?: string | null;
          label?: string | null;
        };
      };
      ingestion_signal: {
        Row: {
          id?: string | null;
          source_name?: string | null;
          source_kind?: string | null;
          source_tier?: string | null;
          source_url?: string | null;
          observed_at?: string | null;
          published_at?: string | null;
          created_at?: string | null;
          companies?: number | null;
          people?: number | null;
          properties?: number | null;
          projects?: number | null;
          records?: number | null;
        };
      };
      ingestion_summary: {
        Row: {
          awaiting_triage?: number | null;
          awaiting_extraction?: number | null;
          failed?: number | null;
          arrived_7d?: number | null;
          resolved_7d?: number | null;
          ignored_7d?: number | null;
          records_7d?: number | null;
          records_24h?: number | null;
        };
      };
      job: {
        Row: {
          id?: string | null;
          kind?: string | null;
          status?: string | null;
          params?: unknown | null;
          requested_by?: string | null;
          progress?: string | null;
          result?: unknown | null;
          artifact?: string | null;
          error?: string | null;
          attempts?: number | null;
          queued_at?: string | null;
          started_at?: string | null;
          finished_at?: string | null;
          heartbeat_at?: string | null;
          artifact_key?: string | null;
          produced_count?: number | null;
          produced_noun?: string | null;
          expected_done_at?: string | null;
        };
      };
      my_campaign: {
        Row: {
          id?: string | null;
          name?: string | null;
          label?: string | null;
          description?: string | null;
          entity_type?: string | null;
          filters?: unknown | null;
          weights?: unknown | null;
          shape?: unknown | null;
          created_by?: string | null;
          created_at?: string | null;
          updated_at?: string | null;
          archived_at?: string | null;
          stage?: string | null;
          stage_order?: number | null;
          stage_at?: string | null;
          stage_by?: string | null;
          auto_enrich?: boolean | null;
          manual_status?: string | null;
          manual_requested_at?: string | null;
          manual_requested_by?: string | null;
          manual_assigned_to?: string | null;
          manual_started_at?: string | null;
          manual_completed_at?: string | null;
          manual_completed_by?: string | null;
          manual_note?: string | null;
          roles?: string[] | null;
          seniorities?: string[] | null;
          contact_state?: string | null;
          research?: unknown | null;
          list_id?: string | null;
          list_at?: string | null;
          list_count?: number | null;
          list_by?: string | null;
          list_note?: string | null;
          list_job_id?: string | null;
          list_job_status?: string | null;
          list_job_error?: string | null;
          measured_at?: string | null;
          properties?: number | null;
          companies?: number | null;
          people?: number | null;
          people_with_mobile?: number | null;
          contacts_need_work?: number | null;
          properties_need_work?: number | null;
          joined_since?: number | null;
          left_since?: number | null;
          not_yet_delivered?: number | null;
          last_export_kind?: string | null;
          last_export_at?: string | null;
          last_export_by?: string | null;
          export_count?: number | null;
          export_job_id?: string | null;
          export_job_kind?: string | null;
          export_job_status?: string | null;
          enrich_job_id?: string | null;
          enrich_job_status?: string | null;
          enrich_batch?: string | null;
          web_members?: number | null;
          web_waiting?: number | null;
          web_expected_done_at?: string | null;
          apollo_open?: number | null;
          last_activity_at?: string | null;
          situation?: string | null;
          where_it_stands?: string | null;
          next_step?: string | null;
          next_step_label?: string | null;
          enrich_job_error?: string | null;
          enrich_job_finished_at?: string | null;
          web_candidates?: number | null;
          lookup_pace_per_hour?: number | null;
          web_queue_hours?: number | null;
          web_needs_confirm?: boolean | null;
          stage_moves?: string[] | null;
          people_with_email?: number | null;
          owners_need_work?: number | null;
          owner_id?: string | null;
          owner_name?: string | null;
          owner_email?: string | null;
          owner_since?: string | null;
          owner_by?: string | null;
          created_by_name?: string | null;
          stage_by_name?: string | null;
          contact_cut?: number | null;
          contact_cut_in_use?: number | null;
          people_taken_at?: string | null;
          properties_with_nobody?: number | null;
          people_everyone?: number | null;
          people_everyone_without_mobile?: number | null;
          contact_per_role?: number | null;
          contact_per_company?: number | null;
          contact_reach_fill?: boolean | null;
          enrich_on?: string | null;
          call_on?: string | null;
          ask_enricher?: boolean | null;
          ask_apollo?: boolean | null;
          calling_words?: string | null;
          calling_warning?: boolean | null;
          follows_name?: string | null;
          follows_label?: string | null;
          followed_by_name?: string | null;
          followed_by_label?: string | null;
          sequence_place?: number | null;
          sequence_length?: number | null;
          sequence_head_name?: string | null;
          sequence_words?: string | null;
          enrichment_rank?: number | null;
          enrichment_words?: string | null;
          people_ahead?: number | null;
          when_calling_words?: string | null;
          when_done_words?: string | null;
        };
      };
      my_capture: {
        Row: {
          id?: string | null;
          url?: string | null;
          title?: string | null;
          submitted_at?: string | null;
          updated_at?: string | null;
          state?: string | null;
          reason?: string | null;
          characters_read?: number | null;
          records?: number | null;
          companies?: number | null;
          people?: number | null;
          properties?: number | null;
          projects?: number | null;
          new_records?: number | null;
          known_records?: number | null;
        };
      };
      notice: {
        Row: {
          id?: string | null;
          kind?: string | null;
          campaign?: string | null;
          recipient?: string | null;
          by?: string | null;
          queued_at?: string | null;
          status?: string | null;
        };
      };
      person: {
        Row: {
          id?: string | null;
          full_name?: string | null;
          employer_id?: string | null;
          employer_name?: string | null;
          title?: string | null;
          level?: string | null;
          job_function?: string | null;
          standing?: string | null;
          effective_standing?: string | null;
          last_confirmed_at?: string | null;
          employment_relevance?: string | null;
          has_email?: boolean | null;
          has_mobile?: boolean | null;
          has_phone?: boolean | null;
          has_linkedin?: boolean | null;
          linkedin_url?: string | null;
          hubspot_status?: string | null;
          hubspot_checked_at?: string | null;
          source_count?: number | null;
          signal_count?: number | null;
          newest_source_date?: string | null;
          source_tiers?: string[] | null;
          created_at?: string | null;
          updated_at?: string | null;
          hubspot_last_contacted_at?: string | null;
          hubspot_last_activity_at?: string | null;
          hubspot_last_activity?: string | null;
          hubspot_owner?: string | null;
          hubspot_contact_count?: number | null;
        };
      };
      person_contact_point: {
        Row: {
          id?: string | null;
          person_id?: string | null;
          kind?: string | null;
          value?: string | null;
          verification_status?: string | null;
          created_at?: string | null;
        };
      };
      processing_grid: {
        Row: {
          worker?: string | null;
          worker_order?: number | null;
          work_kind?: string | null;
          kind_label?: string | null;
          waiting?: number | null;
          change_last_hour?: number | null;
          oldest_at?: string | null;
        };
      };
      processing_kind: {
        Row: {
          key?: string | null;
          label?: string | null;
          sentence?: string | null;
          priority?: string | null;
          priority_until?: string | null;
          searches_per_record?: number | null;
          results_per_search?: number | null;
          pages_waiting?: number | null;
          lookups_queued?: number | null;
          lookup_reasons?: unknown | null;
          calls_today?: number | null;
          spend_today?: number | null;
          spend_share_today?: number | null;
          added_today?: number | null;
          priority_after?: string | null;
          weight?: number | null;
          weight_total?: number | null;
          priority_set_by?: string | null;
          priority_set_at?: string | null;
          daily_allowance?: number | null;
          queued_today?: number | null;
        };
      };
      processing_lookup_window: {
        Row: {
          outcome?: string | null;
          label?: string | null;
          sort_order?: number | null;
          recheck_days?: number | null;
          backoff_factor?: number | null;
          max_days?: number | null;
          waits?: string | null;
        };
      };
      processing_priority_choice: {
        Row: {
          work_kind?: string | null;
          priority?: string | null;
          label?: string | null;
          choice_order?: number | null;
          current?: boolean | null;
          sentence?: string | null;
        };
      };
      processing_spend: {
        Row: {
          work_kind?: string | null;
          label?: string | null;
          calls_today?: number | null;
          input_tokens_today?: number | null;
          output_tokens_today?: number | null;
          cache_read_tokens_today?: number | null;
          cache_write_tokens_today?: number | null;
          spend_today?: number | null;
          added_today?: number | null;
          spend_per_record_today?: number | null;
          calls_7d?: number | null;
          input_tokens_7d?: number | null;
          output_tokens_7d?: number | null;
          cache_read_tokens_7d?: number | null;
          cache_write_tokens_7d?: number | null;
          spend_7d?: number | null;
          added_7d?: number | null;
          spend_per_record_7d?: number | null;
        };
      };
      processing_status: {
        Row: {
          state?: string | null;
          stopped_by?: string | null;
          stopped_service?: string | null;
          stopped_since?: string | null;
          stopped_reason?: string | null;
          clog_worker?: string | null;
          clog_label?: string | null;
          clog_waiting?: number | null;
          clog_out_per_hour?: number | null;
          clog_in_per_hour?: number | null;
          spent_today?: number | null;
          cap_usd?: number | null;
          override_until?: string | null;
          paused_until?: string | null;
          resets_at?: string | null;
          pace_last_hour?: number | null;
          projected_at_reset?: number | null;
          cap_reached_at?: string | null;
          calls_today?: number | null;
          input_tokens_today?: number | null;
          output_tokens_today?: number | null;
          cache_read_tokens_today?: number | null;
          cache_write_tokens_today?: number | null;
          loaded_at?: string | null;
          held_by?: string | null;
          held_service?: string | null;
          held_worker?: string | null;
          held_since?: string | null;
          held_reason?: string | null;
          paused_by?: string | null;
          reserve_usd?: number | null;
          cap_max_usd?: number | null;
          reserve_reached_at?: string | null;
          extract_first?: boolean | null;
          extract_first_holds?: boolean | null;
          extract_first_reason?: string | null;
        };
      };
      processing_switch: {
        Row: {
          key?: string | null;
          label?: string | null;
          applies_to?: string | null;
          sort_order?: number | null;
          on_now?: boolean | null;
          set_by?: string | null;
          set_at?: string | null;
        };
      };
      processing_worker: {
        Row: {
          key?: string | null;
          label?: string | null;
          shape?: string | null;
          unit?: string | null;
          batch?: number | null;
          every_seconds?: number | null;
          concurrency?: number | null;
          paused?: boolean | null;
          batch_min?: number | null;
          batch_max?: number | null;
          concurrency_max?: number | null;
          every_min_seconds?: number | null;
          waiting?: number | null;
          change_last_hour?: number | null;
          items_last_hour?: number | null;
          passes_last_hour?: number | null;
          busy_pct?: number | null;
          clears_state?: string | null;
          clears_at?: string | null;
          spend_today?: number | null;
          calls_today?: number | null;
          last_started_at?: string | null;
          last_finished_at?: string | null;
          last_taken?: number | null;
          last_outcomes?: unknown | null;
          last_error?: string | null;
          open_event_id?: number | null;
          running_since?: string | null;
          bounds_note?: string | null;
          next_pass_at?: string | null;
          pace_fixed?: boolean | null;
          pace_set_by?: string | null;
          pace_set_at?: string | null;
          items_word?: string | null;
        };
      };
      project: {
        Row: {
          id?: string | null;
          name?: string | null;
          kind?: string | null;
          status?: string | null;
          unit_count?: number | null;
          parking_spaces?: number | null;
          announced_at?: string | null;
          groundbreaking_at?: string | null;
          est_completion?: string | null;
          market?: string | null;
          property_id?: string | null;
          property_name?: string | null;
          property_city?: string | null;
          property_state?: string | null;
          person_count?: number | null;
          stakeholder_count?: number | null;
          source_count?: number | null;
          signal_count?: number | null;
          newest_source_date?: string | null;
          source_tiers?: string[] | null;
          created_at?: string | null;
          updated_at?: string | null;
          stage_word?: string | null;
        };
      };
      property: {
        Row: {
          id?: string | null;
          name?: string | null;
          address_line1?: string | null;
          city?: string | null;
          county?: string | null;
          state?: string | null;
          zip?: string | null;
          lat?: number | null;
          lon?: number | null;
          geocode_precision?: string | null;
          geocode_status?: string | null;
          geocoded_at?: string | null;
          property_type?: string | null;
          unit_count?: number | null;
          parking_spaces?: number | null;
          affordable_flag?: boolean | null;
          designations?: string[] | null;
          has_existing_ev_chargers?: boolean | null;
          parcel_id?: string | null;
          census_tract?: string | null;
          jurisdiction_id?: string | null;
          jurisdiction_name?: string | null;
          jurisdiction_permit_access?: string | null;
          owner_company_id?: string | null;
          owner_company_name?: string | null;
          developer_company_id?: string | null;
          developer_company_name?: string | null;
          stakeholder_count?: number | null;
          project_count?: number | null;
          source_count?: number | null;
          signal_count?: number | null;
          newest_source_date?: string | null;
          source_tiers?: string[] | null;
          created_at?: string | null;
          updated_at?: string | null;
        };
      };
      property_stakeholder: {
        Row: {
          id?: string | null;
          property_id?: string | null;
          company_id?: string | null;
          company_name?: string | null;
          company_kind?: string | null;
          company_website?: string | null;
          role?: string | null;
          standing?: string | null;
          effective_from?: string | null;
          effective_to?: string | null;
          last_confirmed_at?: string | null;
          created_at?: string | null;
          updated_at?: string | null;
          property_name?: string | null;
          property_address_line1?: string | null;
          property_city?: string | null;
          property_state?: string | null;
          property_type?: string | null;
          unit_count?: number | null;
        };
      };
      provenance: {
        Row: {
          entity_type?: string | null;
          entity_id?: string | null;
          link_kind?: string | null;
          source_id?: string | null;
          source_name?: string | null;
          source_kind?: string | null;
          source_tier?: string | null;
          publisher_domain?: string | null;
          signal_id?: string | null;
          as_of?: string | null;
          as_of_kind?: string | null;
          link?: string | null;
          asserted_as_of?: string | null;
        };
      };
      record_flag: {
        Row: {
          id?: string | null;
          entity_type?: string | null;
          entity_id?: string | null;
          reason?: string | null;
          note?: string | null;
          duplicate_of?: string | null;
          flagged_by?: string | null;
          flagged_at?: string | null;
          resolved_at?: string | null;
          resolved_by?: string | null;
          resolution?: string | null;
          entity_label?: string | null;
        };
      };
      review_decided: {
        Row: {
          id?: number | null;
          entity_type?: string | null;
          survivor_id?: string | null;
          loser_id?: string | null;
          status?: string | null;
          decided_at?: string | null;
          decision_reason?: string | null;
          ai_same?: boolean | null;
          ai_confidence?: string | null;
          ai_reason?: string | null;
          survivor_label?: string | null;
          loser_label?: string | null;
          undoing?: boolean | null;
          decided_by_label?: string | null;
        };
      };
      review_queue: {
        Row: {
          id?: number | null;
          entity_type?: string | null;
          survivor_id?: string | null;
          loser_id?: string | null;
          survivor_name?: string | null;
          loser_name?: string | null;
          name_sim?: number | null;
          ai_same?: boolean | null;
          ai_confidence?: string | null;
          ai_reason?: string | null;
          found_by?: string | null;
          rule_evidence?: string[] | null;
          created_at?: string | null;
          deferred_until?: string | null;
          deferred?: boolean | null;
          merging?: boolean | null;
          survivor_label?: string | null;
          loser_label?: string | null;
          likely_same?: number | null;
        };
      };
      review_queue_summary: {
        Row: {
          entity_type?: string | null;
          pending?: number | null;
          oldest_pending_days?: number | null;
          merged_by_rules_7d?: number | null;
          merged_by_model_7d?: number | null;
          merged_by_people_7d?: number | null;
          kept_7d?: number | null;
          undone_7d?: number | null;
        };
      };
      role_category: {
        Row: {
          name?: string | null;
          sort_order?: number | null;
          has_apollo_titles?: boolean | null;
        };
      };
      schedule_setting: {
        Row: {
          lead_days?: number | null;
        };
      };
      seniority_level: {
        Row: {
          level?: string | null;
          word?: string | null;
          sort_order?: number | null;
        };
      };
      service_status: {
        Row: {
          service?: string | null;
          last_ok_at?: string | null;
          last_failure_at?: string | null;
          failures_since_ok?: number | null;
          last_error?: string | null;
          failing?: boolean | null;
          resumes_at?: string | null;
        };
      };
      setting_change: {
        Row: {
          id?: number | null;
          changed_at?: string | null;
          changed_by?: string | null;
          table_name?: string | null;
          row_key?: string | null;
          field?: string | null;
          what?: string | null;
          value_type?: string | null;
          old_value?: unknown | null;
          new_value?: unknown | null;
          until_value?: unknown | null;
          effect_ready_at?: string | null;
          effect?: string | null;
        };
      };
      stage_word: {
        Row: {
          status?: string | null;
          word?: string | null;
          word_order?: number | null;
        };
      };
      submitted_url: {
        Row: {
          id?: string | null;
          url?: string | null;
          submitted_by?: string | null;
          submitted_at?: string | null;
          updated_at?: string | null;
          state?: string | null;
          reason?: string | null;
          triage_score?: number | null;
          characters_read?: number | null;
          records_linked?: number | null;
        };
      };
      submitted_url_record: {
        Row: {
          signal_id?: string | null;
          entity_type?: string | null;
          entity_id?: string | null;
          link_kind?: string | null;
          label?: string | null;
        };
      };
      user_account: {
        Row: {
          id?: string | null;
          label?: string | null;
          name?: string | null;
          email?: string | null;
        };
      };
    };
  };
};

export type Campaign = Database["api"]["Views"]["campaign"]["Row"];
export type CampaignBuild = Database["api"]["Views"]["campaign_build"]["Row"];
export type CampaignChange = Database["api"]["Views"]["campaign_change"]["Row"];
export type CampaignCompare = Database["api"]["Views"]["campaign_compare"]["Row"];
export type CampaignCompareRow = Database["api"]["Views"]["campaign_compare_row"]["Row"];
export type CampaignExportHistory = Database["api"]["Views"]["campaign_export_history"]["Row"];
export type CampaignHistory = Database["api"]["Views"]["campaign_history"]["Row"];
export type CampaignList = Database["api"]["Views"]["campaign_list"]["Row"];
export type CampaignOverlap = Database["api"]["Views"]["campaign_overlap"]["Row"];
export type CampaignPeople = Database["api"]["Views"]["campaign_people"]["Row"];
export type CampaignProgress = Database["api"]["Views"]["campaign_progress"]["Row"];
export type CampaignResult = Database["api"]["Views"]["campaign_result"]["Row"];
export type CampaignRun = Database["api"]["Views"]["campaign_run"]["Row"];
export type CandidateProperty = Database["api"]["Views"]["candidate_property"]["Row"];
export type CandidateStateCount = Database["api"]["Views"]["candidate_state_count"]["Row"];
export type Capture = Database["api"]["Views"]["capture"]["Row"];
export type CaptureRecord = Database["api"]["Views"]["capture_record"]["Row"];
export type Company = Database["api"]["Views"]["company"]["Row"];
export type CompanyProject = Database["api"]["Views"]["company_project"]["Row"];
export type CompanyProperty = Database["api"]["Views"]["company_property"]["Row"];
export type Contact = Database["api"]["Views"]["contact"]["Row"];
export type CriteriaSet = Database["api"]["Views"]["criteria_set"]["Row"];
export type EditableField = Database["api"]["Views"]["editable_field"]["Row"];
export type EmailOutbox = Database["api"]["Views"]["email_outbox"]["Row"];
export type EmailRecipient = Database["api"]["Views"]["email_recipient"]["Row"];
export type EmailTemplate = Database["api"]["Views"]["email_template"]["Row"];
export type Employment = Database["api"]["Views"]["employment"]["Row"];
export type EnrichmentBatch = Database["api"]["Views"]["enrichment_batch"]["Row"];
export type EnrichmentGapCount = Database["api"]["Views"]["enrichment_gap_count"]["Row"];
export type EnrichmentMember = Database["api"]["Views"]["enrichment_member"]["Row"];
export type EnrichmentOwner = Database["api"]["Views"]["enrichment_owner"]["Row"];
export type EnrichmentPerson = Database["api"]["Views"]["enrichment_person"]["Row"];
export type EnrichmentProperty = Database["api"]["Views"]["enrichment_property"]["Row"];
export type EnrichmentRequest = Database["api"]["Views"]["enrichment_request"]["Row"];
export type EnrichmentScenario = Database["api"]["Views"]["enrichment_scenario"]["Row"];
export type EnrichmentState = Database["api"]["Views"]["enrichment_state"]["Row"];
export type EntityName = Database["api"]["Views"]["entity_name"]["Row"];
export type Event = Database["api"]["Views"]["event"]["Row"];
export type Feed = Database["api"]["Views"]["feed"]["Row"];
export type FeedCategory = Database["api"]["Views"]["feed_category"]["Row"];
export type FeedSummary = Database["api"]["Views"]["feed_summary"]["Row"];
export type GapWord = Database["api"]["Views"]["gap_word"]["Row"];
export type ImportField = Database["api"]["Views"]["import_field"]["Row"];
export type ImportOutcome = Database["api"]["Views"]["import_outcome"]["Row"];
export type ImportRecord = Database["api"]["Views"]["import_record"]["Row"];
export type ImportValue = Database["api"]["Views"]["import_value"]["Row"];
export type IngestionRecord = Database["api"]["Views"]["ingestion_record"]["Row"];
export type IngestionSignal = Database["api"]["Views"]["ingestion_signal"]["Row"];
export type IngestionSummary = Database["api"]["Views"]["ingestion_summary"]["Row"];
export type Job = Database["api"]["Views"]["job"]["Row"];
export type MyCampaign = Database["api"]["Views"]["my_campaign"]["Row"];
export type MyCapture = Database["api"]["Views"]["my_capture"]["Row"];
export type Notice = Database["api"]["Views"]["notice"]["Row"];
export type Person = Database["api"]["Views"]["person"]["Row"];
export type PersonContactPoint = Database["api"]["Views"]["person_contact_point"]["Row"];
export type ProcessingGrid = Database["api"]["Views"]["processing_grid"]["Row"];
export type ProcessingKind = Database["api"]["Views"]["processing_kind"]["Row"];
export type ProcessingLookupWindow = Database["api"]["Views"]["processing_lookup_window"]["Row"];
export type ProcessingPriorityChoice = Database["api"]["Views"]["processing_priority_choice"]["Row"];
export type ProcessingSpend = Database["api"]["Views"]["processing_spend"]["Row"];
export type ProcessingStatus = Database["api"]["Views"]["processing_status"]["Row"];
export type ProcessingSwitch = Database["api"]["Views"]["processing_switch"]["Row"];
export type ProcessingWorker = Database["api"]["Views"]["processing_worker"]["Row"];
export type Project = Database["api"]["Views"]["project"]["Row"];
export type Property = Database["api"]["Views"]["property"]["Row"];
export type PropertyStakeholder = Database["api"]["Views"]["property_stakeholder"]["Row"];
export type Provenance = Database["api"]["Views"]["provenance"]["Row"];
export type RecordFlag = Database["api"]["Views"]["record_flag"]["Row"];
export type ReviewDecided = Database["api"]["Views"]["review_decided"]["Row"];
export type ReviewQueue = Database["api"]["Views"]["review_queue"]["Row"];
export type ReviewQueueSummary = Database["api"]["Views"]["review_queue_summary"]["Row"];
export type RoleCategory = Database["api"]["Views"]["role_category"]["Row"];
export type ScheduleSetting = Database["api"]["Views"]["schedule_setting"]["Row"];
export type SeniorityLevel = Database["api"]["Views"]["seniority_level"]["Row"];
export type ServiceStatus = Database["api"]["Views"]["service_status"]["Row"];
export type SettingChange = Database["api"]["Views"]["setting_change"]["Row"];
export type StageWord = Database["api"]["Views"]["stage_word"]["Row"];
export type SubmittedUrl = Database["api"]["Views"]["submitted_url"]["Row"];
export type SubmittedUrlRecord = Database["api"]["Views"]["submitted_url_record"]["Row"];
export type UserAccount = Database["api"]["Views"]["user_account"]["Row"];


/* Every column each view returns, for the parts of the app that need
   the list while running rather than while compiling. Generated from
   the same read of the live schema as the types above, so it cannot
   disagree with them. */
export const VIEW_COLUMNS: Record<string, readonly string[]> = {
  campaign: ["id", "name", "label", "description", "entity_type", "filters", "weights", "shape", "created_by", "created_at", "updated_at", "archived_at", "stage", "stage_order", "stage_at", "stage_by", "auto_enrich", "manual_status", "manual_requested_at", "manual_requested_by", "manual_assigned_to", "manual_started_at", "manual_completed_at", "manual_completed_by", "manual_note", "roles", "seniorities", "contact_state", "research", "list_id", "list_at", "list_count", "list_by", "list_note", "list_job_id", "list_job_status", "list_job_error", "measured_at", "properties", "companies", "people", "people_with_mobile", "contacts_need_work", "properties_need_work", "joined_since", "left_since", "not_yet_delivered", "last_export_kind", "last_export_at", "last_export_by", "export_count", "export_job_id", "export_job_kind", "export_job_status", "enrich_job_id", "enrich_job_status", "enrich_batch", "web_members", "web_waiting", "web_expected_done_at", "apollo_open", "last_activity_at", "situation", "where_it_stands", "next_step", "next_step_label", "enrich_job_error", "enrich_job_finished_at", "web_candidates", "lookup_pace_per_hour", "web_queue_hours", "web_needs_confirm", "stage_moves", "people_with_email", "owners_need_work", "owner_id", "owner_name", "owner_email", "owner_since", "owner_by", "created_by_name", "stage_by_name", "contact_cut", "contact_cut_in_use", "people_taken_at", "properties_with_nobody", "people_everyone", "people_everyone_without_mobile", "contact_per_role", "contact_per_company", "contact_reach_fill", "enrich_on", "call_on", "ask_enricher", "ask_apollo", "calling_words", "calling_warning", "criteria_changed_at", "list_behind", "list_behind_words", "follows_name", "follows_label", "followed_by_name", "followed_by_label", "sequence_place", "sequence_length", "sequence_head_name", "sequence_words", "enrichment_rank", "enrichment_words", "people_ahead", "sequence_order", "when_calling_words", "when_done_words", "when_out_words"],
  campaign_build: ["campaign", "list_id", "at", "by_name", "properties", "previous_count", "first", "joined", "left_count", "reasons_recorded", "note"],
  campaign_change: ["campaign", "list_id", "change", "cause", "why", "reasons", "property_id", "in_evie", "label", "city", "state", "id"],
  campaign_compare: ["job_id", "import_job_id", "campaign", "status", "error", "queued_at", "finished_at", "asked_by", "list_id", "list_at", "ran_at", "totals", "reasons", "people", "companies", "criteria"],
  campaign_compare_row: ["job_id", "seq", "property_id", "label", "city", "state", "status", "rank", "reasons"],
  campaign_export_history: ["job_id", "kind", "criteria_set_id", "criteria_set_name", "requested_by", "status", "queued_at", "finished_at", "artifact", "error", "artifact_key"],
  campaign_history: ["campaign", "at", "kind", "what", "by_name", "rows", "list_id", "job_id", "has_file", "failed", "note", "seq", "file"],
  campaign_list: ["member_id", "list_id", "rank", "score", "breakdown", "property_id", "name", "address_line1", "city", "state", "property_type", "unit_count", "owner_company_id", "owner_company_name", "project_status", "stage_word", "stage_order", "people_to_call", "people_with_mobile", "people_taken_at"],
  campaign_overlap: ["campaign", "property_id", "people", "other_owner_name", "other_campaign", "other_label", "sent_at", "words"],
  campaign_people: ["campaign", "criteria_set_id", "list_id", "property_id", "person_id", "full_name", "title", "role_category", "level", "employer_id", "employer_name", "basis", "company_role", "project_role", "fit", "reasons", "above_line", "rank_in_property", "call_order", "email", "mobile", "phone", "linkedin_url", "taken_at"],
  campaign_progress: ["criteria_set_id", "criteria_set_name", "baseline_at", "measured_at", "properties", "companies", "people", "people_with_mobile", "people_with_email", "people_with_linkedin", "properties_added", "properties_left", "companies_change", "people_change", "mobiles_change", "emails_change", "last_export_id", "last_export_at", "not_yet_delivered", "needs_work", "gaps", "needs_words", "added_by_method", "properties_with_nobody", "people_everyone", "people_everyone_without_mobile"],
  campaign_result: ["id", "campaign_id", "campaign_name", "entity_type", "entity_id", "rank", "score", "tier", "breakdown", "entity_label", "entity_subtitle", "created_at"],
  campaign_run: ["id", "name", "criteria_set_id", "criteria_set_name", "ruleset_id", "ruleset_version", "ruleset_active", "criteria_snapshot", "destination", "run_by", "member_count", "frozen_at", "notes", "thin_count", "job_id", "since_campaign_id", "kind"],
  candidate_property: ["id", "name", "address_line1", "city", "state", "zip", "county", "property_type", "unit_count", "affordable_flag", "parking_spaces", "has_existing_ev_chargers", "chargers_state", "lat", "lon", "jurisdiction_name", "owner_company_id", "owner_company_name", "owner_website", "owner_party_kind", "owner_firm_role", "owner_in_hubspot", "stakeholder_role", "portfolio_size", "portfolio_states", "portfolio_units", "people_connected", "owner_senior", "people_to_call", "owner_emails", "owner_mobiles", "owner_linkedins", "ordinance_count", "ordinance_local_count", "ordinance_state_count", "requires_evse", "preempted", "right_to_charge", "program_count", "best_rate_pct", "project_id", "project_status", "project_kind", "project_name", "project_units", "est_completion", "groundbreaking_at", "announced_at", "construction_status", "data_source", "source_link", "source_seen", "standing_stock", "has_reachable_person", "has_connected_person", "has_email", "has_mobile", "has_linkedin", "has_units", "has_coordinates", "has_owner", "has_ordinance", "has_local_ordinance", "has_program", "year_built", "year_renovated", "building_class", "stories", "stage_word", "year_expected_completion", "year_construction_start", "year_permit_estimate"],
  candidate_state_count: ["state", "properties", "with_reachable_person"],
  capture: ["id", "url", "title", "submitted_by", "submitted_at", "processing_status"],
  capture_record: ["signal_id", "entity_type", "entity_id", "label", "address", "is_new"],
  company: ["id", "name", "kind", "website", "hq_city", "hq_state", "relevance", "relevance_reason", "do_not_contact", "do_not_contact_reason", "source_count", "signal_count", "newest_source_date", "source_tiers", "hubspot_status", "hubspot_checked_at", "hubspot_company_id", "property_count", "people_count", "created_at", "updated_at", "counted_at", "hubspot_last_contacted_at", "hubspot_last_activity_at", "hubspot_last_activity", "hubspot_owner", "hubspot_contact_count"],
  company_project: ["company_id", "project_id", "name", "kind", "status", "stage_word", "unit_count", "announced_at", "groundbreaking_at", "est_completion", "newest_source_date", "source_count", "property_id", "property_name", "property_city", "property_state", "roles", "standing"],
  company_property: ["company_id", "company_name", "company_kind", "property_id", "property_name", "property_address_line1", "property_city", "property_state", "property_type", "unit_count", "roles", "ended_roles", "standing", "last_confirmed_at", "source_count"],
  contact: ["basis", "parent_type", "parent_id", "property_id", "person_id", "full_name", "project_role", "title", "level", "job_function", "employment_standing", "effective_standing", "employment_relevance", "employer_id", "employer_name", "employer_kind", "email", "mobile", "phone", "linkedin_url", "person_city", "person_state"],
  criteria_set: ["id", "name", "description", "entity_type", "filters", "weights", "shape", "enrich", "ruleset_id", "ruleset_version", "ruleset_active", "created_by", "created_at", "updated_at", "archived_at", "run_count", "last_run_at", "label", "status", "status_at", "status_by", "last_snapshot_id", "last_snapshot_at", "last_snapshot_destination", "export_count", "last_export_at", "auto_enrich", "manual_status", "manual_requested_at", "manual_requested_by", "manual_assigned_to", "manual_started_at", "manual_completed_at", "manual_completed_by", "manual_note", "manual_history", "roles", "seniorities", "contact_state", "research", "enrich_job_id", "enrich_job_status", "enrich_job_queued_at", "enrich_batch", "contact_cut", "contact_per_role", "contact_per_company", "contact_reach_fill"],
  editable_field: ["entity_type", "field", "data_type", "required", "allowed_values", "label"],
  email_outbox: ["id", "template_key", "template_label", "to_address", "status", "status_reason", "subject", "requested_by", "created_at", "sent_at", "delivered_at", "attempts"],
  email_recipient: ["role", "addresses", "description", "updated_by", "updated_at"],
  email_template: ["key", "label", "description", "subject", "body_text", "body_html", "unsubscribable", "enabled", "updated_by", "updated_at"],
  employment: ["id", "person_id", "person_name", "company_id", "company_name", "company_kind", "title", "level", "job_function", "territory", "standing", "effective_standing", "effective_from", "effective_to", "last_confirmed_at", "relevance", "relevance_reason", "confidence", "created_at", "updated_at", "title_raw"],
  enrichment_batch: ["batch", "members", "queued", "found", "no_result", "unreachable", "signals", "signals_open", "signals_resolved", "first_looked_at", "last_looked_at", "done", "waiting", "never_queued", "waiting_ahead", "pace_per_hour", "expected_done_at"],
  enrichment_gap_count: ["campaign", "entity_type", "gap", "label", "records"],
  enrichment_member: ["batch", "entity_type", "entity_id", "label", "outcome", "looked_at", "signals", "employment", "employment_since_lookup"],
  enrichment_owner: ["campaign", "criteria_set_id", "measured_at", "walk_order", "company_id", "company_name", "website", "hq_city", "hq_state", "property_id", "property_name", "property_city", "property_state", "reasons", "missing", "property_address"],
  enrichment_person: ["campaign", "criteria_set_id", "measured_at", "walk_order", "person_id", "full_name", "employment_id", "title", "employer_id", "employer_name", "property_id", "property_name", "property_city", "property_state", "mobile", "email", "phone", "linkedin_url", "reasons", "missing", "title_editable", "property_address"],
  enrichment_property: ["campaign", "criteria_set_id", "measured_at", "walk_order", "property_id", "property_name", "address_line1", "city", "state", "unit_count", "stage_word", "reasons", "missing"],
  enrichment_request: ["id", "name", "label", "status", "created_by", "auto_enrich", "manual_status", "manual_requested_at", "manual_requested_by", "manual_assigned_to", "manual_started_at", "manual_completed_at", "manual_completed_by", "manual_note", "roles", "seniorities", "contact_state", "research", "measured_at", "properties", "people", "people_with_mobile", "needs_work", "gaps", "needs_words", "properties_since_request", "mobiles_since_request", "people_since_request", "enrich_job_id", "enrich_job_status", "enrich_batch", "web_members", "web_waiting", "web_expected_done_at", "apollo_jobs_open", "properties_with_nobody", "people_everyone", "people_everyone_without_mobile", "contact_cut", "contact_cut_in_use", "call_on", "calling_words", "calling_warning", "follows_label", "sequence_place", "sequence_words", "enrichment_rank", "enrichment_words", "people_ahead"],
  enrichment_scenario: ["key", "name", "roles", "seniorities", "sort_order"],
  enrichment_state: ["entity_type", "entity_id", "state", "requested_at", "requested_by", "reason", "priority", "last_looked_at", "outcome", "attempts", "batch", "recheck_days", "requeueable_after"],
  entity_name: ["entity_type", "entity_id", "name", "source", "first_seen", "last_seen", "seen_count", "source_url"],
  event: ["id", "first_seen_at", "last_seen_at", "occurrences", "source", "kind", "severity", "subject", "summary", "detail", "status", "status_at", "status_by", "status_note", "closed_at"],
  feed: ["id", "name", "feed_url", "feed_type", "category", "scope", "status", "first_party", "source_name", "last_polled_at", "next_poll_at", "last_item_at", "poll_interval_minutes", "consecutive_failures", "last_status", "last_error", "items_seen", "items_kept", "keep_rate_pct", "productive", "due_now", "created_at"],
  feed_category: ["category", "feeds", "productive", "active", "failing", "items_seen", "items_kept", "keep_rate_pct", "last_polled_at"],
  feed_summary: ["feeds", "active", "candidate", "paused", "dead", "productive", "failing", "due_now", "items_seen", "items_kept", "polled_24h"],
  gap_word: ["key", "label", "short_words", "need_words"],
  import_field: ["target", "kind", "label", "position"],
  import_outcome: ["job_id", "entity_type", "outcome", "held", "records"],
  import_record: ["job_id", "signal_id", "entity_type", "entity_id", "label", "address", "outcome", "held"],
  import_value: ["target", "value", "label", "position"],
  ingestion_record: ["signal_id", "entity_type", "entity_id", "link_kind", "created_at", "label"],
  ingestion_signal: ["id", "source_name", "source_kind", "source_tier", "source_url", "observed_at", "published_at", "created_at", "companies", "people", "properties", "projects", "records"],
  ingestion_summary: ["awaiting_triage", "awaiting_extraction", "failed", "arrived_7d", "resolved_7d", "ignored_7d", "records_7d", "records_24h"],
  job: ["id", "kind", "status", "params", "requested_by", "progress", "result", "artifact", "error", "attempts", "queued_at", "started_at", "finished_at", "heartbeat_at", "artifact_key", "produced_count", "produced_noun", "expected_done_at"],
  my_campaign: ["id", "name", "label", "description", "entity_type", "filters", "weights", "shape", "created_by", "created_at", "updated_at", "archived_at", "stage", "stage_order", "stage_at", "stage_by", "auto_enrich", "manual_status", "manual_requested_at", "manual_requested_by", "manual_assigned_to", "manual_started_at", "manual_completed_at", "manual_completed_by", "manual_note", "roles", "seniorities", "contact_state", "research", "list_id", "list_at", "list_count", "list_by", "list_note", "list_job_id", "list_job_status", "list_job_error", "measured_at", "properties", "companies", "people", "people_with_mobile", "contacts_need_work", "properties_need_work", "joined_since", "left_since", "not_yet_delivered", "last_export_kind", "last_export_at", "last_export_by", "export_count", "export_job_id", "export_job_kind", "export_job_status", "enrich_job_id", "enrich_job_status", "enrich_batch", "web_members", "web_waiting", "web_expected_done_at", "apollo_open", "last_activity_at", "situation", "where_it_stands", "next_step", "next_step_label", "enrich_job_error", "enrich_job_finished_at", "web_candidates", "lookup_pace_per_hour", "web_queue_hours", "web_needs_confirm", "stage_moves", "people_with_email", "owners_need_work", "owner_id", "owner_name", "owner_email", "owner_since", "owner_by", "created_by_name", "stage_by_name", "contact_cut", "contact_cut_in_use", "people_taken_at", "properties_with_nobody", "people_everyone", "people_everyone_without_mobile", "contact_per_role", "contact_per_company", "contact_reach_fill", "enrich_on", "call_on", "ask_enricher", "ask_apollo", "calling_words", "calling_warning", "follows_name", "follows_label", "followed_by_name", "followed_by_label", "sequence_place", "sequence_length", "sequence_head_name", "sequence_words", "enrichment_rank", "enrichment_words", "people_ahead", "when_calling_words", "when_done_words"],
  my_capture: ["id", "url", "title", "submitted_at", "updated_at", "state", "reason", "characters_read", "records", "companies", "people", "properties", "projects", "new_records", "known_records"],
  notice: ["id", "kind", "campaign", "recipient", "by", "queued_at", "status"],
  person: ["id", "full_name", "employer_id", "employer_name", "title", "level", "job_function", "standing", "effective_standing", "last_confirmed_at", "employment_relevance", "has_email", "has_mobile", "has_phone", "has_linkedin", "linkedin_url", "hubspot_status", "hubspot_checked_at", "source_count", "signal_count", "newest_source_date", "source_tiers", "created_at", "updated_at", "hubspot_last_contacted_at", "hubspot_last_activity_at", "hubspot_last_activity", "hubspot_owner", "hubspot_contact_count"],
  person_contact_point: ["id", "person_id", "kind", "value", "verification_status", "created_at"],
  processing_grid: ["worker", "worker_order", "work_kind", "kind_label", "waiting", "change_last_hour", "oldest_at"],
  processing_kind: ["key", "label", "sentence", "priority", "priority_until", "searches_per_record", "results_per_search", "pages_waiting", "lookups_queued", "lookup_reasons", "calls_today", "spend_today", "spend_share_today", "added_today", "priority_after", "weight", "weight_total", "priority_set_by", "priority_set_at", "daily_allowance", "queued_today"],
  processing_lookup_window: ["outcome", "label", "sort_order", "recheck_days", "backoff_factor", "max_days", "waits"],
  processing_priority_choice: ["work_kind", "priority", "label", "choice_order", "current", "sentence"],
  processing_spend: ["work_kind", "label", "calls_today", "input_tokens_today", "output_tokens_today", "cache_read_tokens_today", "cache_write_tokens_today", "spend_today", "added_today", "spend_per_record_today", "calls_7d", "input_tokens_7d", "output_tokens_7d", "cache_read_tokens_7d", "cache_write_tokens_7d", "spend_7d", "added_7d", "spend_per_record_7d"],
  processing_status: ["state", "stopped_by", "stopped_service", "stopped_since", "stopped_reason", "clog_worker", "clog_label", "clog_waiting", "clog_out_per_hour", "clog_in_per_hour", "spent_today", "cap_usd", "override_until", "paused_until", "resets_at", "pace_last_hour", "projected_at_reset", "cap_reached_at", "calls_today", "input_tokens_today", "output_tokens_today", "cache_read_tokens_today", "cache_write_tokens_today", "loaded_at", "held_by", "held_service", "held_worker", "held_since", "held_reason", "paused_by", "reserve_usd", "cap_max_usd", "reserve_reached_at", "extract_first", "extract_first_holds", "extract_first_reason"],
  processing_switch: ["key", "label", "applies_to", "sort_order", "on_now", "set_by", "set_at"],
  processing_worker: ["key", "label", "shape", "unit", "batch", "every_seconds", "concurrency", "paused", "batch_min", "batch_max", "concurrency_max", "every_min_seconds", "waiting", "change_last_hour", "items_last_hour", "passes_last_hour", "busy_pct", "clears_state", "clears_at", "spend_today", "calls_today", "last_started_at", "last_finished_at", "last_taken", "last_outcomes", "last_error", "open_event_id", "running_since", "bounds_note", "next_pass_at", "pace_fixed", "pace_set_by", "pace_set_at", "items_word"],
  project: ["id", "name", "kind", "status", "unit_count", "parking_spaces", "announced_at", "groundbreaking_at", "est_completion", "market", "property_id", "property_name", "property_city", "property_state", "person_count", "stakeholder_count", "source_count", "signal_count", "newest_source_date", "source_tiers", "created_at", "updated_at", "stage_word"],
  property: ["id", "name", "address_line1", "city", "county", "state", "zip", "lat", "lon", "geocode_precision", "geocode_status", "geocoded_at", "property_type", "unit_count", "parking_spaces", "affordable_flag", "designations", "has_existing_ev_chargers", "parcel_id", "census_tract", "jurisdiction_id", "jurisdiction_name", "jurisdiction_permit_access", "owner_company_id", "owner_company_name", "developer_company_id", "developer_company_name", "stakeholder_count", "project_count", "source_count", "signal_count", "newest_source_date", "source_tiers", "created_at", "updated_at"],
  property_stakeholder: ["id", "property_id", "company_id", "company_name", "company_kind", "company_website", "role", "standing", "effective_from", "effective_to", "last_confirmed_at", "created_at", "updated_at", "property_name", "property_address_line1", "property_city", "property_state", "property_type", "unit_count"],
  provenance: ["entity_type", "entity_id", "link_kind", "source_id", "source_name", "source_kind", "source_tier", "publisher_domain", "signal_id", "as_of", "as_of_kind", "link", "asserted_as_of"],
  record_flag: ["id", "entity_type", "entity_id", "reason", "note", "duplicate_of", "flagged_by", "flagged_at", "resolved_at", "resolved_by", "resolution", "entity_label"],
  review_decided: ["id", "entity_type", "survivor_id", "loser_id", "status", "decided_at", "decision_reason", "ai_same", "ai_confidence", "ai_reason", "survivor_label", "loser_label", "undoing", "decided_by_label"],
  review_queue: ["id", "entity_type", "survivor_id", "loser_id", "survivor_name", "loser_name", "name_sim", "ai_same", "ai_confidence", "ai_reason", "found_by", "rule_evidence", "created_at", "deferred_until", "deferred", "merging", "survivor_label", "loser_label", "likely_same"],
  review_queue_summary: ["entity_type", "pending", "oldest_pending_days", "merged_by_rules_7d", "merged_by_model_7d", "merged_by_people_7d", "kept_7d", "undone_7d"],
  role_category: ["name", "sort_order", "has_apollo_titles"],
  schedule_setting: ["lead_days"],
  seniority_level: ["level", "word", "sort_order"],
  service_status: ["service", "last_ok_at", "last_failure_at", "failures_since_ok", "last_error", "failing", "resumes_at"],
  setting_change: ["id", "changed_at", "changed_by", "table_name", "row_key", "field", "what", "value_type", "old_value", "new_value", "until_value", "effect_ready_at", "effect"],
  stage_word: ["status", "word", "word_order"],
  submitted_url: ["id", "url", "submitted_by", "submitted_at", "updated_at", "state", "reason", "triage_score", "characters_read", "records_linked"],
  submitted_url_record: ["signal_id", "entity_type", "entity_id", "link_kind", "label"],
  user_account: ["id", "label", "name", "email"],
};

